import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Search } from '@material-ui/icons'
import { InputAdornment, Paper, TextField } from '@material-ui/core'
import ErrorLabel from './ErrorLabel'

const SearchBarIcon = () => (
  <InputAdornment position="start">
    <Search />
  </InputAdornment>
)

function SearchBar({ classes, value, placeholder, onChange, error }) {
  return (
    <Paper className={classes.paper} elevation={2} square>
      <TextField
        className={classes.textField}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        InputProps={{ startAdornment: <SearchBarIcon /> }}
        type='text'
      />
      <ErrorLabel className={classes.error} error={error} />
    </Paper>
  )
}

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

SearchBar.defaultProps = {
  placeholder: 'Search',
  value: '',
  onChange: () => { }
}

const styles = theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1)
  },
  textField: {
    width: '100%'
  },
  error: {
    marginTop: theme.spacing(1)
  }
})

export default withStyles(styles)(SearchBar)